'use client';

import './child-bio-image.scss';

import { useTranslation } from 'react-i18next';

import { HtmlBlock } from '@sola/ark-core/atoms/html/html.js';
import {
  ChildAvailabilityItem,
  ChildDetails,
} from '@sola/schema/dotcom/children/child.js';

import { Image } from '../../atoms/image/image';
import placeholder from './placeholder.png';

type ChildBioImageProps = {
  availability: ChildAvailabilityItem;
  details: ChildDetails;
};

export const ChildBioImage = ({
  details,
  availability,
}: ChildBioImageProps) => {
  const { t } = useTranslation(['bio']);
  const { imageUrl, name, hangul } = details;
  const { minDaysWaiting } = availability;
  const imageURLTransform =
    imageUrl?.replace('w_150', 'f_auto,q_auto,c_scale,w_500') || undefined;

  return (
    <div className="ChildBioImage xl:pr-comfy-xl">
      <figure className="ChildBioImage__Figure">
        <Image
          image={{
            url: imageURLTransform || (placeholder as unknown as string),
            alt: t('bio:picAlt', {
              childName: name.preferred,
              koreanName: hangul.preferred,
            }),
          }}
          lazyLoad="eager"
          aspectRatio="3-4"
          className="ChildBioImage__Figure__img"
        />
        <figcaption className="ChildBioImage__Figure__figcaption label label-xl">
          <HtmlBlock
            htmlString={t('bio:waitingCaption', {
              childName: name.preferred,
              koreanName: hangul.preferred,
              days: minDaysWaiting,
            })}
          />
        </figcaption>
      </figure>
    </div>
  );
};
